import React from 'react';
import {PageHeader} from "../components/page-header";
import TermedWidget from "../components/termed-widget";

function Terminbuchung() {
    return (
        <>
            <PageHeader title={"Termin buchen"}/>
            <div className="flex justify-center px-10 py-10">
                <TermedWidget/>
            </div>
        </>
    );
}

export default Terminbuchung;